<template>
  <div class="vz-seasons">
    <div class="vz-seasons-head" v-if="hasMoreThanOneSeason">
      <vz-select
        class="vz-season-select"
        id="vz-season-select"
        v-model="currentSeason"
        :options="seasonsOptions"
      />
      <transition name="vz-t-fade">
        <span class="vz-seasons-loading" v-show="loading">
          <i class="ic-loader vz-spin"></i>
        </span>
      </transition>
    </div>

    <div
      class="vz-seasons-body"
      :data-hasMoreThanOneSeason="hasMoreThanOneSeason"
    >
      <transition name="vz-t-fade" appear mode="out-in" @enter="emitEnter">
        <div class="vz-season-episodes" v-if="currentEpisodes.length">
          <titles-list-item
            class="vz-episode vz-small-item"
            v-for="episode in currentEpisodes"
            :key="episode.id"
            :info="episode"
            :show-info="false"
            :show-play="true"
            :show-favorite="false"
            @play="playTitle(episode)"
            @rent="selectTitle(episode)"
            @select="selectTitle(episode)"
          >
          </titles-list-item>
        </div>
        <div class="vz-season-empty" v-else-if="!loading">
          <i class="ic-frown" />
          <span>Não há conteúdos a serem mostrados</span>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import VzSelect from 'vsp-web-ui-lib/components/atoms/vz-select.vue';
import TitlesListItem from '@/components/molecules/titles-list-item.vue';

export default {
  name: 'SeasonsBrowser',
  emits: ['select', 'play', 'transition-enter'],
  components: {
    VzSelect,
    TitlesListItem
  },

  props: {
    seasons: {
      type: Array,
      default: [] // [ { id: Number|String, numberOfEpisodes: Number, seasonNumber: Number, series: Number|String } ]
    },
    contentType: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    currentSeason: '',
    episodes: {}, // { id: [ { id, title, descriptions, images, access } ] }
    loading: false
  }),

  computed: {
    currentEpisodes() {
      const seasonId = this.currentSeason;
      if (seasonId && this.episodes[seasonId]?.length) {
        return this.episodes[seasonId];
      }
      return [];
    },

    seasonsOptions() {
      let label;
      switch (this.contentType) {
        case 'TV_SERIES':
          label = 'Temporada';
          break;
        case 'COURSE':
          label = '';
          break;
        default:
          label = 'Temporada';
      }
      return this.seasons.map((item) => ({
        label: `${label} ${item.name}`,
        value: item.id
      }));
    },

    hasMoreThanOneSeason() {
      return this.seasons.length > 1;
    }
  },

  beforeMount() {
    this.initCurrentSeason();
  },

  watch: {
    seasons() {
      this.initCurrentSeason();
    },

    currentSeason(newVal) {
      if (!this.episodes[newVal]) {
        this.loadEpisodes(newVal);
      }
    }
  },

  methods: {
    loadEpisodes(seasonId) {
      if (!this.loading) {
        const { state } = this.$store;
        this.loading = true;
        this.$api.content
          .getContentsOfList(
            state.config.distributor.id,
            state.user.session.token,
            seasonId
          )
          .then((response) => {
            this.$set(
              this.episodes,
              seasonId,
              response?.data?.length ? response.data : []
            );
          })
          .catch((err) => {
            this.$store.dispatch('ui/consoleLog', err.message || err);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    initCurrentSeason() {
      if (this.seasons.length) {
        this.currentSeason = this.seasons[0].id || '';
      }
    },

    selectTitle(titleItem) {
      if (!titleItem?.canOpenDetails) {
        return;
      }

      this.$emit('select', titleItem);
    },

    playTitle(titleItem) {
      this.$emit('play', titleItem);
    },

    emitEnter() {
      this.$emit('transition-enter');
    }
  }
};
</script>






























































<style theme="light-theater" scoped>
.vz-seasons {
  font-size: 0.85em;
  min-height: 232px;
}

.vz-seasons-head {
  position: relative;
  padding: 32px 32px 0;
}

.vz-seasons-loading {
  display: block;
  position: absolute;
  top: 55px;
  right: 100px;
}

.vz-seasons-loading .vz-spin {
  position: absolute;
  top: 0;
  left: 0;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.25);
}

.vz-seasons-body {
  padding-bottom: 1px;
  min-height: 247px;
}

.vz-seasons-body:not(.vz-seasons-body[data-hasMoreThanOneSeason='true']) {
  padding-top: 32px;
}

.vz-season-empty {
  color: rgba(0, 0, 0, 0.3);
  text-align: center;
}

.vz-season-empty .ic-frown {
  font-size: 48px;
}

.vz-season-empty > span {
  display: block;
  margin-top: 4px;
}

.vz-season-episodes {
  padding: 0 8px 8px 32px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.vz-episode {
  margin: 0 16px 16px 0;
}
</style>
